export default function Icon({ source, span }) {
    const isFontAwesome = source?.includes('fa ') || source?.includes('fa-');

    return (
        <legend className="icon">
            <div className="icon">
                {isFontAwesome ? (
                    <i className={source}/>
                ) : (
                    <img src={source} alt="image"/>
                )}
            <span>{ span }</span>
            </div>
        </legend>
    )
 }